// menuData.js
import React, { useEffect, useState } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { IoClipboardOutline } from 'react-icons/io5';
import { Avatar } from 'antd';
import { useAuth } from './contexts/AuthContext';
import { CiCircleCheck } from 'react-icons/ci';
import { GrDocumentStore } from 'react-icons/gr';
import { IoChatboxEllipsesOutline } from 'react-icons/io5';
import { IoMdSearch } from 'react-icons/io';
import { api } from './services/apiClient.js';

// Supondo que `userImage` e outras variáveis dinâmicas sejam gerenciadas aqui ou passadas de alguma forma

export const useMenuData = () => {
  const { user } = useAuth();
  const userImage = null;
  const [dataSidebar, setDataSidebar] = useState([]);

  // Requisição para buscar logs da operação
  useEffect(() => {
    api
      .get(`/get-data-sidebar`)
      .then((response) => {
        setDataSidebar(response.data);
        console.log('\n\n\n\n\nnresponse.data', response.data);
      })
      .catch((error) => {
        message.error('Erro ao buscar logs da operação.');
        console.error(error);
      });
  }, []);

  const menuData = [
    // {
    //   key: 'user',
    //   icon: userImage ? <Avatar src={userImage} size={40} /> : <Avatar icon={<UserOutlined />} size={40} />,
    //   title: user?.nome,
    //   to: '/',
    //   isVisible: true,
    //   requiredUserLevel: 3,
    // },
    {
      key: 'dashboard',
      icon: (
        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
          <path d='M12 5.69L17 10.19V18H15V12H9V18H7V10.19L12 5.69ZM12 3L2 12H5V20H11V14H13V20H19V12H22L12 3Z' fill='#9E9E9E' />
        </svg>
      ),
      title: 'Dashboard',
      to: '/',
      isVisible: true,
      hasDividerBefore: true,
      requiredUserLevel: 3,
    },
    {
      key: 'chat',
      icon: (
        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
          <path d='M4 4H20V16H5.17L4 17.17V4ZM4 2C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2H4ZM6 12H14V14H6V12ZM6 9H18V11H6V9ZM6 6H18V8H6V6Z' fill='#9E9E9E' />
        </svg>
      ),
      title: 'Chat',
      to: '/chat',
      isVisible: true,
      hasDividerBefore: false,
      requiredUserLevel: 3,
    },
    {
      key: 'consulta',
      icon: (
        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
          <path
            d='M15.5 14H14.71L14.43 13.73C15.4439 12.554 16.0011 11.0527 16 9.5C16 8.21442 15.6188 6.95772 14.9046 5.8888C14.1903 4.81988 13.1752 3.98676 11.9874 3.49479C10.7997 3.00282 9.49279 2.87409 8.23192 3.1249C6.97104 3.3757 5.81285 3.99477 4.90381 4.90381C3.99477 5.81285 3.3757 6.97104 3.1249 8.23192C2.87409 9.49279 3.00282 10.7997 3.49479 11.9874C3.98676 13.1752 4.81988 14.1903 5.8888 14.9046C6.95772 15.6188 8.21442 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z'
            fill='#9E9E9E'
          />
        </svg>
      ),
      title: 'Consultas',
      to: '/consultas',
      isVisible: true,
      hasDividerBefore: false,
      requiredUserLevel: 3,
    },

    {
      key: 'operacao',
      icon: (
        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
          <path
            d='M16.59 7.58L10 14.17L6.41 10.59L5 12L10 17L18 9L16.59 7.58ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z'
            fill='#9E9E9E'
          />
        </svg>
      ),
      title: 'Operações',
      isVisible: true,
      hasDividerBefore: false,
      requiredUserLevel: 3,
      children: [
        { key: 'clientes', title: 'Novo Cadastro', to: '/cadastro/clientes', isVisible: true, requiredUserLevel: 3 },
        { key: 'analise', title: 'Análise', to: '/analise', isVisible: true, requiredUserLevel: 2, count: dataSidebar?.analise },
        { key: 'aprovado', title: 'Aprovado', to: '/aprovado', isVisible: true, requiredUserLevel: 2, count: dataSidebar?.aprovado },
        { key: 'aconfirmar', title: 'A Confirmar', to: '/aconfirmar', isVisible: true, requiredUserLevel: 2, count: dataSidebar?.confirmar },
        { key: 'acordos', title: 'Acordos', to: '/financeiro/acordos', isVisible: true, requiredUserLevel: 0, count: dataSidebar?.acordo },
      ],
    },
    {
      key: 'bases',
      icon: (
        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
          <path
            d='M13.5117 1.7561H5.51172C4.98129 1.7561 4.47258 1.96682 4.09751 2.34189C3.72243 2.71696 3.51172 3.22567 3.51172 3.7561V19.7561C3.51172 20.2865 3.72243 20.7952 4.09751 21.1703C4.47258 21.5454 4.98129 21.7561 5.51172 21.7561H17.5117C18.0422 21.7561 18.5509 21.5454 18.9259 21.1703C19.301 20.7952 19.5117 20.2865 19.5117 19.7561V7.7561M13.5117 1.7561L19.5117 7.7561M13.5117 1.7561L13.5117 7.7561H19.5117M15.5117 12.7561H7.51172M15.5117 16.7561H7.51172M9.51172 8.7561H7.51172'
            stroke='#9E9E9E'
            stroke-width='2'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </svg>
      ), // Substitua por seu ícone de Bases
      title: 'Bases',
      isVisible: true,
      requiredUserLevel: 3,
      children: [
        { key: 'baseClientes', title: 'Clientes', to: '/bases/clientes', isVisible: true, requiredUserLevel: 3 },
        // { key: 'baseUsuario', title: 'Usuários', to: '/bases/usuarios', isVisible: true, requiredUserLevel: 0 },
        { key: 'baseContratos', title: 'Contratos', to: '/bases/contratos', isVisible: true, requiredUserLevel: 3 },
        // { key: 'baseMetas', title: 'Metas', to: '/bases/metas', isVisible: true, requiredUserLevel: 1 },
        { key: 'blackList', title: 'BlackList', to: '/bases/blacklist', isVisible: true, requiredUserLevel: 3 },
      ],
    },
    // {
    //   key: 'relatorios',
    //   icon: (
    //     <svg xmlns='http://www.w3.org/2000/svg' width='23' height='23' viewBox='0 0 23 23' fill='none'>
    //       <path
    //         d='M7.48985 8.6825C6.97759 8.6825 6.56232 9.09777 6.56232 9.61003C6.56232 10.1223 6.97759 10.5376 7.48985 10.5376H14.9101C15.4224 10.5376 15.8377 10.1223 15.8377 9.61003C15.8377 9.09777 15.4224 8.6825 14.9101 8.6825H7.48985Z'
    //         fill='#AA965D'
    //       />
    //       <path
    //         d='M7.48985 12.3926C6.97759 12.3926 6.56232 12.8079 6.56232 13.3202C6.56232 13.8324 6.97759 14.2477 7.48985 14.2477H11.2C11.7123 14.2477 12.1275 13.8324 12.1275 13.3202C12.1275 12.8079 11.7123 12.3926 11.2 12.3926H7.48985Z'
    //         fill='#AA965D'
    //       />
    //       <path
    //         d='M7.48985 16.1028C6.97759 16.1028 6.56232 16.5181 6.56232 17.0303C6.56232 17.5426 6.97759 17.9579 7.48985 17.9579H14.9101C15.4224 17.9579 15.8377 17.5426 15.8377 17.0303C15.8377 16.5181 15.4224 16.1028 14.9101 16.1028H7.48985Z'
    //         fill='#AA965D'
    //       />
    //       <path
    //         fillRule='evenodd'
    //         clipRule='evenodd'
    //         d='M19.4354 5.09997C19.3607 4.91931 19.2512 4.75518 19.1129 4.61701L16.1934 1.69753C15.9154 1.41914 15.5382 1.26255 15.1447 1.26221H4.33623C3.94263 1.26221 3.56516 1.41856 3.28684 1.69688C3.00853 1.97519 2.85217 2.35267 2.85217 2.74626V20.1839C2.85217 20.3788 2.89056 20.5718 2.96514 20.7519C3.03972 20.9319 3.14903 21.0955 3.28684 21.2333C3.42465 21.3711 3.58825 21.4805 3.76831 21.555C3.94837 21.6296 4.14135 21.668 4.33623 21.668H18.0638C18.2586 21.668 18.4516 21.6296 18.6317 21.555C18.8117 21.4805 18.9753 21.3711 19.1132 21.2333C19.251 21.0955 19.3603 20.9319 19.4349 20.7519C19.5094 20.5718 19.5478 20.3788 19.5478 20.1839V5.66829L18.6203 5.668L19.5478 5.67028L19.5478 5.66829C19.548 5.47331 19.5098 5.28018 19.4354 5.09997ZM13.9826 5.43612C13.9826 6.20452 14.6055 6.82742 15.3739 6.82742H17.6928V19.8129H4.70725V3.11728H13.9826V5.43612ZM16.8448 4.97235L15.8377 3.96525V4.97235H16.8448Z'
    //         fill='#AA965D'
    //       />
    //     </svg>
    //   ), // Substitua por seu ícone de Relatórios
    //   title: 'Relatórios',
    //   isVisible: true,
    //   requiredUserLevel: 0,
    //   children: [
    //     { key: 'contaCorrente', title: 'Conta Corrente', to: '/relatorios/contacorrente', isVisible: true, requiredUserLevel: 0 },
    //     { key: 'comColaboradores', title: 'Com. Colaboradores', to: '/relatorios/comcolaboradores', isVisible: true, requiredUserLevel: 0 },
    //     { key: 'areaDoSocio', title: 'Área do Sócio', to: '/relatorios/areasocio', isVisible: true, requiredUserLevel: 0 },
    //     { key: 'fluxoDeCaixarel', title: 'Fluxo de Caixa', to: '/relatorios/fluxocaixarel', isVisible: true, requiredUserLevel: 0 },
    //     { key: 'saldo', title: 'Saldo', to: '/relatorios/saldo', isVisible: true, requiredUserLevel: 0 },
    //     { key: 'justificativas', title: 'Justificativas', to: '/relatorios/justificativas', isVisible: true, requiredUserLevel: 0 },
    //   ],
    // },
    {
      key: 'financeiro',
      icon: (
        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
          <path
            d='M11.8003 10.9C9.53031 10.31 8.80031 9.7 8.80031 8.75C8.80031 7.66 9.81031 6.9 11.5003 6.9C13.2803 6.9 13.9403 7.75 14.0003 9H16.2103C16.1403 7.28 15.0903 5.7 13.0003 5.19V3H10.0003V5.16C8.06031 5.58 6.50031 6.84 6.50031 8.77C6.50031 11.08 8.41031 12.23 11.2003 12.9C13.7003 13.5 14.2003 14.38 14.2003 15.31C14.2003 16 13.7103 17.1 11.5003 17.1C9.44031 17.1 8.63031 16.18 8.52031 15H6.32031C6.44031 17.19 8.08031 18.42 10.0003 18.83V21H13.0003V18.85C14.9503 18.48 16.5003 17.35 16.5003 15.3C16.5003 12.46 14.0703 11.49 11.8003 10.9Z'
            fill='#9E9E9E'
          />
        </svg>
      ), // Substitua pelo ícone apropriado
      title: 'Financeiro',
      isVisible: true,
      requiredUserLevel: 0,
      children: [
        { key: 'resultados', title: 'Resultados', to: '/financeiro/resultados', isVisible: true, requiredUserLevel: 0 },
        { key: 'contratosgestao', title: 'Resumo operacional', to: '/financeiro/contratogestao', isVisible: true, requiredUserLevel: 0 },
        { key: 'contatoscolaboradores', title: 'Contratos colaboradores', to: '/financeiro/contratocolaboradores', isVisible: true, requiredUserLevel: 0 },
        { key: 'fluxoDeCaixa', title: 'Lançamento de despesas', to: '/financeiro/fluxodecaixa', isVisible: true, requiredUserLevel: 0 },
        { key: 'fluxoDiario', title: 'Fluxo de caíxa', to: '/financeiro/fluxodiario', isVisible: true, requiredUserLevel: 0 },
      ],
    },
    {
      key: 'configuracoes',
      icon: (
        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
          <path
            d='M19.4298 12.98C19.4698 12.66 19.4998 12.34 19.4998 12C19.4998 11.66 19.4698 11.34 19.4298 11.02L21.5398 9.37005C21.7298 9.22005 21.7798 8.95005 21.6598 8.73005L19.6598 5.27005C19.6009 5.16687 19.5071 5.08807 19.3953 5.04775C19.2836 5.00744 19.1611 5.00825 19.0498 5.05005L16.5598 6.05005C16.0398 5.65005 15.4798 5.32005 14.8698 5.07005L14.4898 2.42005C14.4733 2.30239 14.4144 2.19481 14.3242 2.11748C14.234 2.04016 14.1186 1.9984 13.9998 2.00005H9.99984C9.74984 2.00005 9.53984 2.18005 9.50984 2.42005L9.12984 5.07005C8.51984 5.32005 7.95984 5.66005 7.43984 6.05005L4.94984 5.05005C4.89186 5.03038 4.83107 5.02025 4.76984 5.02005C4.59984 5.02005 4.42984 5.11005 4.33984 5.27005L2.33984 8.73005C2.20984 8.95005 2.26984 9.22005 2.45984 9.37005L4.56984 11.02C4.52984 11.34 4.49984 11.67 4.49984 12C4.49984 12.33 4.52984 12.66 4.56984 12.98L2.45984 14.63C2.26984 14.78 2.21984 15.05 2.33984 15.27L4.33984 18.73C4.39879 18.8332 4.49256 18.912 4.60434 18.9523C4.71612 18.9927 4.8386 18.9918 4.94984 18.95L7.43984 17.95C7.95984 18.35 8.51984 18.68 9.12984 18.93L9.50984 21.58C9.53984 21.82 9.74984 22 9.99984 22H13.9998C14.2498 22 14.4598 21.82 14.4898 21.58L14.8698 18.93C15.4798 18.68 16.0398 18.34 16.5598 17.95L19.0498 18.95C19.1098 18.97 19.1698 18.98 19.2298 18.98C19.3998 18.98 19.5698 18.89 19.6598 18.73L21.6598 15.27C21.7798 15.05 21.7298 14.78 21.5398 14.63L19.4298 12.98ZM17.4498 11.27C17.4898 11.58 17.4998 11.79 17.4998 12C17.4998 12.21 17.4798 12.43 17.4498 12.73L17.3098 13.86L18.1998 14.56L19.2798 15.4L18.5798 16.61L17.3098 16.1L16.2698 15.68L15.3698 16.36C14.9398 16.68 14.5298 16.92 14.1198 17.09L13.0598 17.52L12.8998 18.65L12.6998 20H11.2998L11.1098 18.65L10.9498 17.52L9.88984 17.09C9.45984 16.91 9.05984 16.68 8.65984 16.38L7.74984 15.68L6.68984 16.11L5.41984 16.62L4.71984 15.41L5.79984 14.57L6.68984 13.87L6.54984 12.74C6.51984 12.43 6.49984 12.2 6.49984 12C6.49984 11.8 6.51984 11.57 6.54984 11.27L6.68984 10.14L5.79984 9.44005L4.71984 8.60005L5.41984 7.39005L6.68984 7.90005L7.72984 8.32005L8.62984 7.64005C9.05984 7.32005 9.46984 7.08005 9.87984 6.91005L10.9398 6.48005L11.0998 5.35005L11.2998 4.00005H12.6898L12.8798 5.35005L13.0398 6.48005L14.0998 6.91005C14.5298 7.09005 14.9298 7.32005 15.3298 7.62005L16.2398 8.32005L17.2998 7.89005L18.5698 7.38005L19.2698 8.59005L18.1998 9.44005L17.3098 10.14L17.4498 11.27ZM11.9998 8.00005C9.78984 8.00005 7.99984 9.79005 7.99984 12C7.99984 14.21 9.78984 16 11.9998 16C14.2098 16 15.9998 14.21 15.9998 12C15.9998 9.79005 14.2098 8.00005 11.9998 8.00005ZM11.9998 14C10.8998 14 9.99984 13.1 9.99984 12C9.99984 10.9 10.8998 10 11.9998 10C13.0998 10 13.9998 10.9 13.9998 12C13.9998 13.1 13.0998 14 11.9998 14Z'
            fill='#9E9E9E'
          />
        </svg>
      ), // Substitua por seu ícone de Configurações
      title: 'Configurações',
      isVisible: true,
      hasDividerBefore: true, // Adiciona um Divider antes deste item
      requiredUserLevel: 1,
      children: [
        { key: 'metas', title: 'Metas', to: '/cadastro/metas', isVisible: true, requiredUserLevel: 0 },
        { key: 'usuarios', title: 'Cadastrar Usuários', to: '/cadastro/usuarios', isVisible: true, requiredUserLevel: 0 },
        { key: 'baseUsuario', title: 'Base Usuários', to: '/bases/usuarios', isVisible: true, requiredUserLevel: 0 },
      ],
    },
  ];

  return menuData;
};
